import "./releaseNotes.scss";

import PropTypes from "prop-types";
import PubSub from "pubsub-js";
import React, { PureComponent } from "react";
import { connect } from "react-redux";

import FormButton from "../../components/form/FormButton";
import ModalBody from "../../components/modal/ModalBody";
import ModalFooter from "../../components/modal/ModalFooter";
import ModalFooterRightGroup from "../../components/modal/ModalFooterRightGroup";
import ModalHeading from "../../components/modal/ModalHeading";
import ModalView from "../../components/modal/ModalView";
import PubSubTopics from "../../constants/pubSubTopics";
import { autoUpdatesSelectors } from "../../modules/autoUpdates";
import { nativeCommsBroadcastMessageTypes } from "../../nativeComms";
import { mergeDispatchToProps } from "../../utils/codeSplit";
import preprocessorQuery from "../../utils/preprocessorQuery";

class ReleaseNotesModal extends PureComponent {
  constructor(props, context) {
    super(props, context);
    this.onCloseClick = this.onCloseClick.bind(this);
  }

  onCloseClick() {
    PubSub.publish(PubSubTopics.sendNativeMessage, {
      msg: nativeCommsBroadcastMessageTypes.RELEASE_NOTES_READ
    });
  }

  render() {
    const releaseNoteHtml = this.props.availableReleaseNotes;
    const modalHeading = <ModalHeading title={"What's New"} showDone={true} onDoneClick={this.onCloseClick} />;
    const modalFooter = preprocessorQuery.isIos() ? null : (
      <ModalFooter>
        <ModalFooterRightGroup>
          <FormButton primary={true} label={"Close"} onClick={this.onCloseClick} />
        </ModalFooterRightGroup>
      </ModalFooter>
    );

    return (
      <ModalView
        className="releaseNotesModal"
        header={modalHeading}
        footer={modalFooter}
        onBackdropClick={this.onCloseClick}
      >
        <ModalBody>
          <div className="releaseNotes">
            {/* eslint-disable-next-line react/no-danger */}
            <div className="releaseNotesHtml" key="notesHtml" dangerouslySetInnerHTML={{ __html: releaseNoteHtml }} />
          </div>
        </ModalBody>
      </ModalView>
    );
  }
}

ReleaseNotesModal.propTypes = {
  availableReleaseNotes: PropTypes.string.isRequired
};

const mapStateToProps = state => {
  const autoUpdatesData = autoUpdatesSelectors.getAutoUpdatesData(state.present);

  return {
    availableReleaseNotes: autoUpdatesData.availableReleaseNotes
  };
};

const readonlyActions = {
  // onCloseClick: autoUpdatesOperations.hideReleaseNotes
};

const editingActions = {};

const mapDispatchToProps = dispatch => mergeDispatchToProps(readonlyActions, editingActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ReleaseNotesModal);
